import React from 'react';
import PropTypes from 'prop-types';

import { ZoneEditor } from '@weezevent/throne';
import { Card, Button, RadioLabel, Icon, Message, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import ZoneEditModal from './editModal';
import Styles from './zoneEditorContainer.module.css';

export default function ZoneEditorContainer({ zone, parent, currentZone, handlePoints, handleStyle, clear, handleSwitchType }) {
    const { t } = useTranslation();
    const [editModalOpen, setEditModalOpen] = React.useState(false);

    return (
        <>
            <ZoneEditModal zone={currentZone} parent={parent} onSubmit={handleStyle} editModalOpen={editModalOpen} setEditModalOpen={setEditModalOpen} />
            <Card className={Styles['zone-list']}>
                <Card.Header>
                    <div className={Styles['card-title-container']}>
                        <div className={Styles['card-title']}>{t('ticket.charts.zone_editor.title')}</div>
                        <div className={Styles['action-buttons']}>
                            {currentZone && (
                                <Button primary inverted onClick={() => clear(currentZone.uuid)}>
                                    {t('ticket.charts.zone_editor.cta.clear_for_zone', { zone_name: currentZone.name })}
                                </Button>
                            )}
                            <Button
                                primary
                                inverted
                                disabled={!currentZone}
                                label={
                                    <>
                                        <Icon name="color-fill" />
                                        <span>{t('ticket.charts.custom.chart.personalize')}</span>
                                    </>
                                }
                                onClick={() => setEditModalOpen(true)}
                            />
                        </div>
                    </div>
                </Card.Header>
                <Card.Content>
                    <div className={`${Styles['container']} ${currentZone ? Styles['current-zone-active'] : ''}`}>
                        <div>
                            <Message type="default" title={t('ticket.charts.custom.chart.message-title')}>
                                <div className={Styles['modal_subtitle']}>
                                    <span>{t('ticket.charts.custom.chart.message-subtitle')}</span>
                                    <span>{t('ticket.charts.custom.chart.message-subtitle-complement')}</span>
                                </div>
                            </Message>
                        </div>
                        <div className={Styles['change_type']}>
                            {!zone && (
                                <div>
                                    <div className={Styles['radio-button-container-title']}>{t('ticket.charts.zone_editor.cta.change_type.label')}</div>
                                    <div className={Styles['radio-button-container']}>
                                        <RadioLabel
                                            className={Styles['radio-label-custom']}
                                            inline
                                            bordered
                                            active={parent.seatlib_data.map_type !== 'realistic'}
                                            name="schematic"
                                            checked={parent.seatlib_data.map_type !== 'realistic'}
                                            label={
                                                <div>
                                                    {t('ticket.charts.zone_editor.cta.change_type.schematic')}
                                                    <TooltipHelp triggerOnHover title={t('ticket.charts.zone_editor.cta.change_type.info.schematic')} />
                                                </div>
                                            }
                                            onClick={() => {
                                                handleSwitchType(false);
                                            }}
                                        />
                                        <RadioLabel
                                            className={Styles['radio-label-custom']}
                                            inline
                                            bordered
                                            active={parent.seatlib_data.map_type === 'realistic'}
                                            name="realistic"
                                            checked={parent.seatlib_data.map_type === 'realistic'}
                                            label={
                                                <div>
                                                    {t('ticket.charts.zone_editor.cta.change_type.realistic')}
                                                    <TooltipHelp triggerOnHover title={t('ticket.charts.zone_editor.cta.change_type.info.realistic')} />
                                                </div>
                                            }
                                            onClick={() => {
                                                handleSwitchType(true);
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        <ZoneEditor zone={parent} onDoubleClick={handlePoints} allowDrawing={Boolean(currentZone)} />
                    </div>
                </Card.Content>
            </Card>
        </>
    );
}

ZoneEditorContainer.propTypes = {
    organization: PropTypes.object.isRequired,
    chart: PropTypes.object.isRequired,
    zone: PropTypes.object,
    onDone: PropTypes.func,
    onZoneSelected: PropTypes.func
};
